import { Layout, Section } from 'layout';
import { FamilyWorkspaceScreen } from 'pages/inquiry-processor/screens/family-workspace-screen';
import { InquiryDetailScreen } from 'pages/inquiry-processor/screens/inquiry-detail-screen';
import { MasterProductFamiliesScreen } from 'pages/inquiry-processor/screens/master-product-families-screen';
import { MatchMakerScreen } from 'pages/inquiry-processor/screens/match-maker-screen';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

const InquiryProcessorPage = () => {
  const match = useRouteMatch();

  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          {/* Pretzel Match Maker (design handoff) — two-pane rail + detail. */}
          <Route path={`${match.url}/list`} component={MatchMakerScreen} />
          {/* Family workspace MUST precede the list route below — the list
              path is non-exact and would otherwise swallow /:familyId. */}
          <Route path={`${match.url}/master-products/:familyId`} component={FamilyWorkspaceScreen} />
          <Route path={`${match.url}/master-products`} component={MasterProductFamiliesScreen} />
          <Route path={`${match.url}/inquiry/:id`} component={InquiryDetailScreen} />
          <Redirect to={`${match.url}/list`} exact />
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default InquiryProcessorPage;
